import React from "react";
import classNames from "classnames";
import { DEFAULT_GUILD_CREST, guildAsset } from "../utils";
import { useAppTranslation } from "../../../i18n/useAppTranslation";

type Props = {
  image?: string | null;
  size?: "small" | "medium" | "large";
  level?: number;
  className?: string;
};

// A guild's picture in the game's round frame, with its level when one is given.
export default function GuildCrest({ image, size = "medium", level, className }: Props) {
  const { t } = useAppTranslation("guild");
  return (
    <div className={classNames("gh-crest", `is-${size}`, className)}>
      {image && <img src={guildAsset(image, DEFAULT_GUILD_CREST)} alt="" />}
      {level ? <span className="gh-crest-level">{t("guild:crestLevel", { level })}</span> : null}
    </div>
  );
}
